module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-model-material-configurator-options-heading]').each(function() {
    var modelId = $(this).attr('data-sw-model-material-configurator-options-heading');
    var el = this;
    require(
      [
        'vue',
        'vuex',
        'rrViewComponents/Model/MaterialConfigurator/sw-model-material-configurator-module',
        'rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorOptionsHeadingComponent/tpl.model-material-configurator-options-heading-vue.mustache'
      ], function (vue, vuex, modelMaterialConfiguratorModule, tpl) {
        new vue({
          el: el,
          data: {
            modelId: modelId
          },
          template: tpl.render(),
          store: modelMaterialConfiguratorModule,
          computed: vuex.mapState({
            hasMaterialGroupSelected: function (state) {
              return state[this.modelId].hasMaterialGroupSelected;
            }
          })
        });
      });
  });
};
